/**
 * Signature Look Section JS
 */
if (!window.__signatureLookInitialized) {
  window.__signatureLookInitialized = true;

  /* ── Media stack ──
     The role model, the reseat trick and the transition steps below are the
     same ones featured-products-with-visual.js uses, so both sections move
     identically. The only difference is what drives them: this section has no
     arrows, so the media visible on either side of the active card is the
     control. */
  var SL_ROLE_CLASSES = ['is-card', 'is-backdrop', 'is-behind', 'is-ahead'];

  function setupSignatureLookMedia(wrapper) {
    wrapper.classList.add('is-initialized');

    var mediaItems = Array.prototype.slice.call(wrapper.querySelectorAll('.js-signature-media-item'));
    var mediaCount = mediaItems.length;

    if (mediaCount < 2) return;

    var navZones = wrapper.querySelectorAll('.js-signature-nav');
    var wrapperStyles = window.getComputedStyle(wrapper);
    var duration = parseFloat(wrapperStyles.getPropertyValue('--sl-duration')) || 800;

    var mediaIndex = 0;
    var isAnimating = false;
    var animationTimer = null;

    function wrapMedia(index) {
      return ((index % mediaCount) + mediaCount) % mediaCount;
    }

    function roleFor(i, activeMedia) {
      var behindBy = (activeMedia - i + mediaCount) % mediaCount;
      if (behindBy === 0) return 'is-card';
      if (behindBy === 1) return 'is-backdrop';
      if (behindBy === 2) return 'is-behind';
      return 'is-ahead';
    }

    function isAnimatedStep(from, to) {
      return (
        (from === 'is-card' && to === 'is-backdrop') ||
        (from === 'is-ahead' && to === 'is-card') ||
        (from === 'is-backdrop' && to === 'is-card') ||
        (from === 'is-card' && to === 'is-ahead')
      );
    }

    function syncVideos() {
      mediaItems.forEach(function (host) {
        var onScreen = host.classList.contains('is-card') || host.classList.contains('is-backdrop');
        var videos = host.querySelectorAll('video');
        Array.prototype.forEach.call(videos, function (video) {
          if (onScreen) {
            if (video.paused) {
              var played = video.play();
              if (played && typeof played.catch === 'function') {
                played.catch(function () {});
              }
            }
          } else if (!video.paused) {
            video.pause();
          }
        });
      });
    }

    function transitionMedia(targetMedia) {
      targetMedia = wrapMedia(targetMedia);
      if (targetMedia === mediaIndex) return;

      var oldRoles = mediaItems.map(function (item, i) { return roleFor(i, mediaIndex); });
      var newRoles = mediaItems.map(function (item, i) { return roleFor(i, targetMedia); });

      var preSeated = [];
      mediaItems.forEach(function (item, i) {
        var from = oldRoles[i];
        var to = newRoles[i];
        var needsReseat = to === 'is-card' && from === 'is-behind';

        if (from === to) return;

        if (!isAnimatedStep(from, to) || needsReseat) {
          item.classList.add('is-no-anim');
          item.classList.remove.apply(item.classList, SL_ROLE_CLASSES);
          item.classList.add(needsReseat ? 'is-ahead' : to);
          if (needsReseat) preSeated.push(i);
        }
      });

      void wrapper.offsetWidth;

      mediaItems.forEach(function (item, i) {
        item.classList.remove('is-no-anim');
        if (oldRoles[i] === newRoles[i]) return;
        if (isAnimatedStep(oldRoles[i], newRoles[i]) || preSeated.indexOf(i) !== -1) {
          item.classList.remove.apply(item.classList, SL_ROLE_CLASSES);
          item.classList.add(newRoles[i]);
        }
      });

      mediaIndex = targetMedia;
      syncVideos();
    }

    function seatStack(targetMedia) {
      mediaIndex = wrapMedia(targetMedia);
      mediaItems.forEach(function (item, i) {
        item.classList.add('is-no-anim');
        item.classList.remove.apply(item.classList, SL_ROLE_CLASSES);
        item.classList.add(roleFor(i, mediaIndex));
      });
      void wrapper.offsetWidth;
      mediaItems.forEach(function (item) { item.classList.remove('is-no-anim'); });
    }

    /* The reference section leans on Splide to swallow clicks mid-slide.
       Without a slider here, hold the step until the transform has landed so a
       double click can never restart the stack halfway through. */
    function step(dir) {
      if (isAnimating) return;

      isAnimating = true;
      clearTimeout(animationTimer);
      animationTimer = setTimeout(function () {
        isAnimating = false;
      }, duration + 60);

      transitionMedia(mediaIndex + (dir === 'prev' ? -1 : 1));
    }

    Array.prototype.forEach.call(navZones, function (zone) {
      zone.addEventListener('click', function (e) {
        e.preventDefault();
        step(zone.dataset.direction === 'prev' ? 'prev' : 'next');
      });
    });

    var touchStartX = 0;
    var touchStartY = 0;

    wrapper.addEventListener(
      'touchstart',
      function (e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      },
      { passive: true }
    );

    wrapper.addEventListener(
      'touchend',
      function (e) {
        var deltaX = e.changedTouches[0].screenX - touchStartX;
        var deltaY = e.changedTouches[0].screenY - touchStartY;
        var threshold = 40;

        if (Math.abs(deltaX) < threshold || Math.abs(deltaX) < Math.abs(deltaY)) return;

        step(deltaX < 0 ? 'next' : 'prev');
      },
      { passive: true }
    );

    seatStack(0);
    syncVideos();
  }

  function initSignatureLookMedia() {
    var wrappers = document.querySelectorAll('.js-signature-media:not(.is-initialized)');
    Array.prototype.forEach.call(wrappers, setupSignatureLookMedia);
  }

  document.addEventListener('DOMContentLoaded', initSignatureLookMedia);
  window.addEventListener('load', initSignatureLookMedia);

  if (document.readyState !== 'loading') {
    initSignatureLookMedia();
  }

  if ('MutationObserver' in window) {
    var signatureLookPending = false;
    new MutationObserver(function (mutations) {
      if (signatureLookPending) return;
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType === 1) {
            if (node.matches('.js-signature-media') || node.querySelector('.js-signature-media')) {
              signatureLookPending = true;
              requestAnimationFrame(function () {
                signatureLookPending = false;
                initSignatureLookMedia();
              });
              return;
            }
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Handle Single Product Add to Cart
  document.addEventListener('click', function (e) {
    var singleAddBtn = e.target.closest('.js-signature-add-single');
    if (!singleAddBtn) return;

    e.preventDefault();
    var variantId = singleAddBtn.dataset.variantId;
    if (!variantId) return;

    singleAddBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        if (typeof refreshCart === 'function') {
          refreshCart();
        }
        if (typeof openCartDrawer === 'function') {
          openCartDrawer();
        }
      })
      .catch(function (err) {
        console.error('Error adding product to cart:', err);
      })
      .finally(function () {
        singleAddBtn.disabled = false;
      });
  });

  // Handle Add All to Cart
  document.addEventListener('click', function (e) {
    var addAllBtn = e.target.closest('.js-signature-add-all');
    if (!addAllBtn) return;

    e.preventDefault();
    var section = addAllBtn.closest('.section-signature-look');
    if (!section) return;

    var productItems = section.querySelectorAll('.signature-look__product-item[data-available="true"]');
    if (!productItems.length) return;

    var items = [];
    productItems.forEach(function (item) {
      var variantId = item.dataset.variantId;
      if (variantId) {
        items.push({
          id: variantId,
          quantity: 1
        });
      }
    });

    if (!items.length) return;

    addAllBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: items
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add all to cart failed');
        return res.json();
      })
      .then(function () {
        if (typeof refreshCart === 'function') {
          refreshCart();
        }
        if (typeof openCartDrawer === 'function') {
          openCartDrawer();
        }
      })
      .catch(function (err) {
        console.error('Error adding all products to cart:', err);
      })
      .finally(function () {
        addAllBtn.disabled = false;
      });
  });
}
